/**
 * @fileoverview > handler for the "/integrations/direct/cdi/import-syncs/:import_sync_id/sync_now" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsCdiImportNowCacheKeys } from "./constants";
import type { PostCdiSyncNowProps, CdiSyncNowResult } from "./types";

export const postIntegrationCdiSyncNow = reactQueryMutationAdapter(
  integrationsCdiImportNowCacheKeys,
  (props: PostCdiSyncNowProps): Promise<CdiSyncNowResult> => {
    return fetch(`/integrations/direct/cdi/import-syncs/${props.importSyncId}/sync_now`, "POST");
  }
);
